import { createEvent, restore } from 'effector';

import { KEYCLOAK_CLIENTID } from 'shared/config';

import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://b2e.rosaid.itlabs.io',
  realm: 'rosaid',
  clientId: KEYCLOAK_CLIENTID,
});

const setIsAuthenticated = createEvent<boolean>();
const setToken = createEvent<string | null>();

const updateToken = () => {
  keycloak
    .updateToken(70)
    .then(() => {
      setToken(keycloak.token || null);
    })
    .catch(() => {
      keycloak.logout();
    });
};

let updateTokenInterval: number;
keycloak.onAuthSuccess = () => {
  updateTokenInterval = window.setInterval(updateToken, 60 * 1000);
  setToken(keycloak.token || null);
  setIsAuthenticated(true);
};

keycloak.onTokenExpired = () => {
  keycloak.updateToken(70);
};

keycloak.onAuthError = (err) => {
  // eslint-disable-next-line no-console
  console.error(err);
};

keycloak.init({ onLoad: 'login-required', checkLoginIframe: false });

export const $isAuthenticated = restore(setIsAuthenticated, false);
export const $token = restore(setToken, null);
export const logout = () => {
  clearInterval(updateTokenInterval);
  keycloak.logout();
};
